define('modules/editor/models/property_groups/page_privacy',['require','exports','module','./base'],function(require,exports,module){
  "use strict";
  var BasePropertyGroup = require("./base");
  module.exports = BasePropertyGroup.extend({
    name: "page:privacy",
    properties: ["active", "message", "linkUrl", "linkText", "title"],
    defaults: {
      "active": false,
      "message": "",
      "linkUrl": "",
      "linkText": ""
    },
    validators: {
      "linkUrl": function(attrs){
        return attrs.linkUrl === "" || this.isValidUrl(attrs.linkUrl);
      }
    }
  });
});

